import { Analytics as DubAnalytics } from '@dub/analytics/react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { ConsoleProvider } from './types';
import { loadGTM } from './utils/gtm';

/** Hookdeck properties Dub decorates with the click id (dub_id) for cross-domain attribution. */
const DUB_OUTBOUND_DOMAINS = ['hookdeck.com', 'dashboard.hookdeck.com', 'console.hookdeck.com'];

// Google Tag Manager, fullpage entry only — the embeddable lib build (src/lib.tsx)
// runs on third-party sites where injecting GTM would be wrong. No-op in
// development or without GTM_ID (see utils/gtm.ts).
loadGTM();

let query_provider;
try {
  if (window.location.search) {
    const params = new URLSearchParams(window.location.search);
    query_provider = params.get('provider') || params.get('producer');
    params.delete('provider');
    params.delete('producer');
    const new_params_string = params.toString();
    if (query_provider) {
      let url = window.location.pathname;
      if (new_params_string.length > 0) {
        url += `?${new_params_string}`;
      }
      window.history.replaceState({}, document.title, url);
    }
  }
} catch (error) {
  console.error(error);
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <ErrorBoundary>
    <App
      context="fullpage"
      telemetry={true}
      provider={(query_provider as ConsoleProvider) || undefined}
    />
    {/*
      Dub Analytics, loaded first-party via /_proxy/dub (see clients/vercel.json rewrites).
      Mounted only in this fullpage entry — the embeddable lib build runs on third-party
      sites where the proxy doesn't exist. The cookie lives on the apex domain so
      hookdeck.com, the dashboard, and the API see the same click id. Skipped in
      development to keep local traffic out of Dub.
    */}
    {VITE_APP_ENV !== 'development' && (
      <DubAnalytics
        apiHost="/_proxy/dub"
        scriptProps={{ src: '/_proxy/dub/script.js' }}
        domainsConfig={{ outbound: DUB_OUTBOUND_DOMAINS }}
        cookieOptions={{ domain: `.${VITE_ROOT_DOMAIN}` }}
      />
    )}
  </ErrorBoundary>,
);
